import { TriangleAlert } from "lucide-react";
import { useNavigate } from "react-router";
import { PARAMETER_IDENTITE_CSE_PATH } from "@/shared/configs/routes.config";
import { Button } from "@/shared/ui/Button";

type SidebarLogoProps = {
  isLoading: boolean
  logo?: { url: string } | null
  collapsed: boolean
};

const SidebarLogo = ({ isLoading, logo, collapsed }: SidebarLogoProps) => {
  const navigate = useNavigate();

  if (collapsed) return null;

  return (
    <div className="flex justify-center items-center p-2">
      {isLoading
        ? (
          <div className="h-10 w-36 bg-gray-200 rounded-lg" />
        )
        : logo?.url
          ? (
            <img
              className="w-full h-16 object-contain max-w-48 max-h-24"
              src={logo.url}
              alt="Votre logo"
            />
          )
          : (
            <div className="flex w-full items-center justify-center">
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate(PARAMETER_IDENTITE_CSE_PATH)}
              >
                <TriangleAlert size={16} />
                Ajouter un logo
              </Button>
            </div>
          )}
    </div>
  );
};

export default SidebarLogo;
